<template>
  <div class="pandemy-info">
    <div class="content-wrapper">
      <div class="pandemy-info">
        <span v-html="'Ważne informacje o pandemii. Sprawdź bieżące zalecenia i&nbsp;komunikaty.'"></span>
        <a target="_blank" rel="noopener noreferrer" href="https://www.gov.pl/web/koronawirus">Czytaj więcej</a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    // 
  };
</script>

<style lang="scss" scoped>
  @import "@/scss/_general.scss";

  .pandemy-info {
    padding-top: 20px;
    padding-bottom: 20px;

    .content-wrapper {
      
      .pandemy-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        font-size: 22px;
        background: #ffca05;
        font-weight: 600;
        padding: 15px 24px;
        line-height: 30px;

        @media only screen and (max-width: 1200px) {
          flex-direction: column;
          text-align: center;
        }

        span {
            display: inline;
        }

        a {
          font-size: 14px;
          color: #000;
          text-decoration: none;
          font-weight: 600;

          &:hover {
            text-decoration: underline;
          }

          @media only screen and (max-width: 1200px) {
            margin-top: 10px;
          }
        }
      }
    }
  }
</style>